import set from 'set-value';

const setValue = (obj: any, path: string, value: any) => {
  return { ...set(obj, path, value) };
};

export default setValue;
